import React from 'react';
import { Register } from '../factory';

@Register({ name: 'dy-textarea' })
class DyTextArea extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleChange = e => {
        let value = e.target.value;
        this.props.onChange && this.props.onChange(value);
    };

    render() {
        let { className, name, value, placeholder, rows, maxLength } = this.props;
        return (
            <div className={`dy-fm-item ${className ? className : ''}`}>
                <textarea
                    className="dy-fm-input"
                    value={value}
                    name={name}
                    maxLength={maxLength || 500}
                    onChange={this.handleChange}
                    placeholder={placeholder || '请输入'}
                    rows={rows || 2}
                />
            </div>
        );
    }
}

export default DyTextArea;
